import React, { useEffect } from "react";
import BodyIntro from "../../components/landingPage/BodyIntro";
import BookWithUs from "../../components/landingPage/BookWithUs";
import DemoService from "../../components/landingPage/DemoService";
import Header from "../../components/landingPage/Header";
import OurServices from "../../components/landingPage/OurServices";
import "aos/dist/aos.css";
import AOS from "aos";
import Footer from "../../components/landingPage/Footer";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";

const LandingPage = () => {
  const navigate = useNavigate();
  const { token } = useSelector((state) => state.auth);

  useEffect(() => {
    // for initializing aos for animate on scroll
    AOS.init({
      duration: 2000,
    });
  }, []);

  useEffect(() => {
    if (token) {
      navigate("/home");
    }
  }, [token, navigate]);

  return (
    <div className="bg-gray-50">
      <Header className="static z-40" />
      {/* body intro container - section 1 */}
      <BodyIntro />
      {/* why book with us - section 2 */}
      <BookWithUs />
      {/* Our Services  */}
      <OurServices />
      {/* car animation */}
      {/* <div className="hidden sm:hidden md:hidden lg:inline ">
        <DemoService />
      </div> */}
      {/* footer */}
      <Footer />
    </div>
  );
};

export default React.memo(LandingPage);
